import { toByteArray } from 'base64-js';
import EJSON from 'ejson';
import { Binary, Literal, Ref, Template } from './types';
EJSON.addType('Template', function fromJSONValue(json) {
    return new Template(json.source, EJSON.fromJSONValue(json.context));
});
EJSON.addType('Binary', function fromJSONValue(json) {
    return new Binary(toByteArray(json.data));
});
EJSON.addType('Literal', function fromJSONValue(json) {
    return new Literal(EJSON.fromJSONValue(json.value));
});
EJSON.addType('Ref', function fromJSONValue(json) {
    return new Ref(EJSON.fromJSONValue(json.value));
});
export const toJSON = (value) => {
    return EJSON.toJSONValue(value);
};
export const fromJSON = (value) => {
    return EJSON.fromJSONValue(value);
};
export const stringify = (value) => {
    return EJSON.stringify(value);
};
export const parseJsonString = (value) => {
    return EJSON.parse(value);
};
//# sourceMappingURL=ejsonUtils.js.map